import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediatorPipe } from './mediator.pipe';
@NgModule({
  declarations: [MediatorPipe],
  imports: [CommonModule],
  exports: [MediatorPipe],
})
export class MediatorModule {}
